export enum EModalIds {
  SelectModal = 'select-modal',
  SelectDateModal = 'select-date-modal',

  SelectCountryModal = 'select-country-modal',
  SelectCurrencyModal = 'select-currency-modal',
  SelectCompanyTypeModal = 'select-company-type-modal',

  ConfirmDeleteMemberModal = 'confirm-delete-member-modal',
  MemberManagementModal = 'member-management-modal',
  MemberPepManagementModal = 'member-pep-management-modal',

  ConfirmDeletePaymentFlow = 'confirm-delete-payment-flow',
}
